import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router";
import { HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { MetaMaskProvider } from "metamask-react";

import "./assets/styles/theme.scss";
import CodiaxIndex from "./pages/web/codiax";

class App extends React.PureComponent {
	render() {
		return (
			<MetaMaskProvider>
				<ToastContainer
					autoClose={3000}
					position="bottom-right"
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					pauseOnFocusLoss
					draggable
				/>
				<HashRouter>
					<Switch>
						<Route
							path="/"
							exact
							render={() => <CodiaxIndex />}
						/>
						<Route path="/codiax" component={CodiaxIndex} />
					</Switch>
				</HashRouter>
			</MetaMaskProvider>
		);
	}
}

const mapStateToProps = (state) => ({
	isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(App);
